module.exports = __webpack_public_path__ + "img/backlogin.5ebda869.svg";